<!-- 現在沒在用，換到view去了 -->
<template>
</template>

<script>
export default {
    name: 'Form-Setting',

    data() {
        return {
 
        }
    },

    computed: {
    },

    components: {

    },

    watch: {

    },

    methods: {

    },


    async mounted() {
    },


}
</script>
